module.exports = __webpack_public_path__ + "static/media/VERIFIED_1.143168f3.svg";